import axios from '@/request/http'
import global from '@/constants/Global.constants'

export default {
  companyList (params) {
    return axios.post(global.IMS_INFO + '/logisticsCompany/findAllLogisticsCompany', params)
  },
  companyUpdate (params) {
    return axios.post(global.IMS_INFO + '/logisticsCompany/updateLogisticsCompany', params)
  },
  companyDelete (params) {
    return axios.post(global.IMS_INFO + '/logisticsCompany/deleteLogisticsCompany', params)
  },
  companyInsert (params) {
    return axios.post(global.IMS_INFO + '/logisticsCompany/insertLogisticsCompany', params)
  }
}



// WEBPACK FOOTER //
// ./src/request/ims/company.js